import { useI18n } from '../i18n'
import { COLORS } from '../lib/board'
import { useTools } from '../store/session'

type Props = {
  onUndo: () => void
  onClear?: () => void
  onPhoto?: () => void
}

/** Единый инструментарий на всех холстах: палитра, карандаш/кисть, 3 толщины, undo. */
export function Toolbar({ onUndo, onClear, onPhoto }: Props) {
  const { t } = useI18n()
  const tools = useTools()

  return (
    <div className="toolbar">
      <div className="tb-row">
        {COLORS.map((c) => (
          <button
            key={c}
            className={'swatch' + (c === tools.color ? ' sel' : '')}
            style={{ background: c }}
            aria-label={c}
            onClick={() => tools.set({ color: c })}
          />
        ))}
      </div>
      <div className="tb-row">
        {(['pen', 'brush'] as const).map((tool) => (
          <button
            key={tool}
            className={'tool-btn' + (tools.tool === tool ? ' sel' : '')}
            title={tool}
            onClick={() => tools.set({ tool })}
          >
            {tool === 'pen' ? '✏️' : '🖌'}
          </button>
        ))}
        {([0, 1, 2] as const).map((i) => (
          <button
            key={i}
            className={'wdot' + (tools.size === i ? ' sel' : '')}
            aria-label={'width ' + (i + 1)}
            onClick={() => tools.set({ size: i })}
          >
            <i style={{ width: [6, 10, 15][i], height: [6, 10, 15][i] }} />
          </button>
        ))}
        <button className="tool-btn" onClick={onUndo} aria-label="undo">↺</button>
        {onClear && (
          <button className="tool-btn" onClick={onClear}>
            {t.draw.clear}
          </button>
        )}
        {onPhoto && (
          <button className="tool-btn" onClick={onPhoto}>
            {t.draw.photo}
          </button>
        )}
      </div>
    </div>
  )
}
